import src from "IMAGE";
export default { src, width: 133, height: 154, blurWidth: 0, blurHeight: 0};
